import { render, staticRenderFns } from "./Quicksearch.vue?vue&type=template&id=e83553c6&"
import script from "./Quicksearch.vue?vue&type=script&lang=js&"
export * from "./Quicksearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/studip/studip/studip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e83553c6')) {
      api.createRecord('e83553c6', component.options)
    } else {
      api.reload('e83553c6', component.options)
    }
    module.hot.accept("./Quicksearch.vue?vue&type=template&id=e83553c6&", function () {
      api.rerender('e83553c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/Quicksearch.vue"
export default component.exports